import { useState } from "react";

import { Banner, Box, Card, Icon, Image, Tag, Typography } from "@luce/ui";

import { PaymentProofSheet } from "./payment-proof-sheet";

const REMINDER_COPY = "Please upload payment proof if payment has been done in the past 3 days.";

interface PaymentProofCardProps {
  invoiceId: string;
  uploadedUrl: string | null;
}

export function PaymentProofCard({ invoiceId, uploadedUrl }: PaymentProofCardProps) {
  const [open, setOpen] = useState(false);

  return (
    <Box className="gap-spacing-sm flex flex-col">
      <Banner variant="info" description={REMINDER_COPY} />

      <Card
        direction="row"
        onPress={() => setOpen(true)}
        accessibilityLabel="Upload payment proof"
        className="w-full justify-between"
      >
        <Card.Header className="flex-1">
          <Box className="gap-spacing-sm flex flex-row items-center">
            <Card.Title>Payment Proof</Card.Title>
            <Tag variant="neutral" size="sm">
              Optional
            </Tag>
          </Box>
          <Card.Description>Upload your receipt or transfer screenshot.</Card.Description>
        </Card.Header>

        {uploadedUrl ? (
          <Box className="rounded-radius-sm border-luce-neutral-border-mediumEmphasis overflow-hidden border">
            <Image
              src={uploadedUrl}
              alt="Payment proof"
              width={32}
              height={32}
              contentFit="cover"
            />
          </Box>
        ) : (
          <Box className="gap-spacing-xs flex flex-row items-center">
            <Typography variant="label-sm" color="brand-primary">
              Upload
            </Typography>
            <Icon name="CaretRight" size={16} className="text-luce-brand-primary" />
          </Box>
        )}
      </Card>

      <PaymentProofSheet
        invoiceId={invoiceId}
        uploadedUrl={uploadedUrl}
        open={open}
        onOpenChange={setOpen}
      />
    </Box>
  );
}
